import { ExpenseInfo } from './types';

/**
 * Compare 2 expenses only by reason and payment method for sorting
 *
 * @param expenseA expense to use for compare
 * @param expenseB expense to compare againt
 */
export const compareExpenses = (expenseA: ExpenseInfo, expenseB: ExpenseInfo): -1 | 0 | 1 => {
  const expenseReasonA = expenseA.reason;
  const expenseReasonB = expenseB.reason;
  if (expenseReasonA > expenseReasonB) {
    return 1;
  }

  if (expenseReasonA < expenseReasonB) {
    return -1;
  }

  const paymentMethodA = expenseA.paymentMethod;
  const paymentMethodB = expenseB.paymentMethod;
  if (paymentMethodA > paymentMethodB) {
    return 1;
  }

  if (paymentMethodA < paymentMethodB) {
    return -1;
  }

  return 0;
};
